import React from 'react';
import DesligamentoModelo from './DesligamentoModelo'

export default function TelaDesligamentos({ dados, dadosPessoa }) {
    const sociedades = agruparPorSociedade(dados);

    function agruparPorSociedade(dados) {
        const mapaSociedades = {};

        if (dados.compositorAutorFiliado) {
            const soc = dados.sociedadeCompositorAutor;
            if (!mapaSociedades[soc]) {
                mapaSociedades[soc] = criarObjetoSociedade(soc);
            }
            mapaSociedades[soc].exibeCategoriaAutor = true;
        }

        if (dados.InterpreteFiliado) {
            const soc = dados.sociedadeInterprete;
            if (!mapaSociedades[soc]) {
                mapaSociedades[soc] = criarObjetoSociedade(soc);
            }
            mapaSociedades[soc].exibeCategoriaInterprete = true;
        }

        if (dados.musicoFiliado) {
            const soc = dados.sociedadeMusico;
            if (!mapaSociedades[soc]) {
                mapaSociedades[soc] = criarObjetoSociedade(soc);
            }
            mapaSociedades[soc].exibeCategoriaMusico = true;
        }

        if (dados.produtorFonograficoFiliado) {
            const soc = dados.sociedadeProdutor;
            if (!mapaSociedades[soc]) {
                mapaSociedades[soc] = criarObjetoSociedade(soc);
            }
            mapaSociedades[soc].exibeCategoriaProdutor = true;
        }

        if (dados.editorFiliado) {
            const soc = dados.sociedadeEditor;
            if (!mapaSociedades[soc]) {
                mapaSociedades[soc] = criarObjetoSociedade(soc);
            }
            mapaSociedades[soc].exibeCategoriaEditor = true;
        }

        return Object.values(mapaSociedades);
    }

    function criarObjetoSociedade(nome) {
        return {
            societyName: nome,
            exibeCategoriaAutor: false,
            exibeCategoriaInterprete: false,
            exibeCategoriaMusico: false,
            exibeCategoriaEditor: false,
            exibeCategoriaProdutor: false,
        };
    }

    const estiloQuebraLinha = { 'page-break-after': 'auto', 'break-after': 'page' };

    return (
        <div>
            {sociedades.map((soc, index) => (
                <>
                    <div style={estiloQuebraLinha}></div>
                    <DesligamentoModelo
                        key={index}
                        sociedade={soc.societyName}
                        nomeAssinatura={dadosPessoa?.nome}
                        documentoAssinatura={dadosPessoa?.cpf}
                        exibeCategoriaAutor={soc.exibeCategoriaAutor}
                        exibeCategoriaInterprete={soc.exibeCategoriaInterprete}
                        exibeCategoriaMusico={soc.exibeCategoriaMusico}
                        exibeCategoriaEditor={soc.exibeCategoriaEditor}
                        exibeCategoriaProdutor={soc.exibeCategoriaProdutor}
                    />
                </>
            ))}
        </div>
    );
}
